/**
 * Loads preview payload for the documents grid / viewer (same logic as list preview dialog).
 *
 * @param {object} doc document row from API
 * @param {{ documentAssetUrl: (id: string, segment: string) => string, getAuthAccessToken: () => string | null }} ctx
 */
export async function fetchDocumentPreviewContent(doc, { documentAssetUrl, getAuthAccessToken }) {
  const ext = doc.file_name?.split('.').pop()?.toLowerCase();
  const token = getAuthAccessToken();
  const headers = { Authorization: `Bearer ${token}` };
  const previewUrl = documentAssetUrl(doc.id, 'preview');

  if (ext === 'txt') {
    const response = await fetch(previewUrl, { headers });
    if (!response.ok) throw new Error('Failed to fetch');
    const text = await response.text();
    return { type: 'text', content: text };
  }
  if (['doc', 'docx', 'rtf'].includes(ext)) {
    const response = await fetch(previewUrl, { headers });
    if (!response.ok) throw new Error('Failed to fetch');
    const html = await response.text();
    return { type: 'html', content: html };
  }
  if (['png', 'jpg', 'jpeg', 'gif'].includes(ext)) {
    const response = await fetch(previewUrl, { headers });
    if (!response.ok) throw new Error('Failed to fetch');
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    return { type: 'image', url: objectUrl, isBlob: true };
  }
  if (ext === 'pdf') {
    const response = await fetch(previewUrl, { headers });
    if (!response.ok) throw new Error('Failed to fetch');
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    return { type: 'pdf', url: objectUrl, isBlob: true };
  }
  return { type: 'unsupported' };
}
